/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：752
 */

module.exports = {
  iconLayoutItem: "style_iconLayoutItem__3TAM3",
  iconBox: "style_iconBox__2VCwG",
  delete: "style_delete__2wJTJ",
  iconDelete: "style_iconDelete__2QzDX",
  content: "style_content__3qxCd",
  fileItemName: "style_fileItemName__2QXUf"
}
